// src/lib/api/crm/leads.ts
import { http } from '@/shared/api/http';
import type { DeepRequired, Schema, WithOptional } from '@/shared/api';

// 08.08.2026 бэк развернул sql.Null*: title/statusId приходят плоскими строками.
// name — имя контакта лида (NAME + LAST_NAME), crmRef — например "L_22896".
export type CrmLead = WithOptional<
  DeepRequired<Schema<'tasks_module_internal_models.Lead'>>,
  'statusId' | 'name' | 'crmRef'
>;

export interface CrmLeadsParams {
  /** CSV id — резолв конкретных лидов (префилл), игнорирует search/статусы. */
  ids?: string;
  /** Поиск по подстроке (название/имя/телефон) по всем лидам. */
  search?: string;
  limit?: number;
  offset?: number;
}

export const fetchCrmLeads = async (
  params?: CrmLeadsParams
): Promise<{ result: CrmLead[]; total?: number }> => {
  const { data } = await http.get<{ result: CrmLead[]; total?: number }>(
    '/crm/leads/list',
    { params }
  );
  return data;
};
